import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { COMPANY_TYPE, CE_TYPE } from 'constant';

import { 
	MainPage, 
	LoginPage, 
	NoticePage,
	QnaBoardPage,

	CompanyInfoPage,
	CompanyManagePage,

	CenterManagePage,

	GoodsManagePage,
	GoodsGroupManagePage,

	OrderPage,
	TransPage, 
	TransHistoryPage,
	
	OrderReturnPage,
	StatsPage,

	NotAuthPage,
	NotFoundPage 
} from 'pages';

@inject("commonStore")
@observer
class App extends Component {
	
	UNSAFE_componentWillMount() {
    this.props.commonStore.onSessionCheck();
	}
	
	render() {
		const { sessionLoginInfo } = this.props.commonStore;
		const ceType = sessionLoginInfo?.ceType;
		const cGbn = sessionLoginInfo?.cGbn;
			
		return (
			<Fragment>
				{!sessionLoginInfo && <Redirect to={`/login`} />}
				<Switch>
					<Route exact path="/" component={ MainPage } />
					<Route path="/login" component={ LoginPage } />
					{/* 공지사항 */}
					<Route path="/notice" component={ NoticePage } />
					{/* Q&A 게시판 */}
					<Route path="/qnaBoard" 
						component={(cGbn === COMPANY_TYPE.KNP) 
							? QnaBoardPage : NotAuthPage}/>
					{/* YUJIN S&A */}
					<Route path="/companyInfo" component={ CompanyInfoPage } />
					{/* 근무복주문 */}
					<Route path="/orderManage" component={ OrderPage } />
					{/* 주문관리 */}
					<Route path="/transManage" component={ TransPage } />
					{/* 구매이력 */}
					<Route path="/transHistory" component={ TransHistoryPage } />

					{/* 정산관리 */}
					{/* <Route path="/settleManage"component={SettleManagePage} /> */}
					{/* 사원관리 */}
					{/* <Route path="/userManage"component={UserManagePage} /> */}
					{/* 직무관리 */}
					{/* <Route path="/jobManage"component={JobManagePage} /> */}
					{/* 상품이용정보관리 */}
					{/* <Route path="/goodsJobManage"component={GoodsJobManagePage} /> */}

					{/* 회사관리 */}
					<Route path="/centerManage"
						component={(ceType === CE_TYPE.YUJIN 
							|| ceType === CE_TYPE.MASTER
							|| (cGbn === COMPANY_TYPE.BENZ && ceType === CE_TYPE.BRANCH)
						)
							? CenterManagePage : NotAuthPage}/>

          {/* 상품관리 */}
					<Route path="/goodsManage"
						component={(ceType === CE_TYPE.YUJIN 
							|| ceType === CE_TYPE.MASTER
							|| (cGbn === COMPANY_TYPE.BENZ && ceType === CE_TYPE.BRANCH)
						)
							? GoodsManagePage : NotAuthPage}/>

					{/* 반품관리 */}
					<Route path="/orderReturn"
						component={(ceType === CE_TYPE.YUJIN)
							? OrderReturnPage : NotAuthPage}/>

					{/* 상품군관리 */}
					<Route path="/goodsGroupManage"
						component={(ceType === CE_TYPE.YUJIN) 
							? GoodsGroupManagePage : NotAuthPage}/>

					{/* 유진정보관리 */}
					<Route path="/companyManage" 
						component={(ceType === CE_TYPE.YUJIN) 
							? CompanyManagePage : NotAuthPage}/>

					{/* 통계 */}
					<Route path="/stats"
						component={(ceType === CE_TYPE.YUJIN 
							|| ceType === CE_TYPE.MASTER
							|| (cGbn === COMPANY_TYPE.BENZ && ceType === CE_TYPE.BRANCH)
						)
							? StatsPage : NotAuthPage}/>

					<Route component = {NotFoundPage}/>
				</Switch> 
			</Fragment>
		);
	}
};

export default App;